import './wdyr';
import './style.css';
import { createRoot } from 'react-dom/client';
import App from './App';
// Important to extend Date prototype before App renders
import './Utils/date.util';
import React from 'react';
import { Filters } from './Models/Filters';
import { msalInstance } from './msalInstance';
import { useStore } from './store/store';

// Need to init store state before rendering the app because sometimes the store initialization
// is done before the class Filters is imported by the files, causing a constructor error
useStore.setState({ leftFilters: new Filters() });

await msalInstance.initialize();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
